import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { Card, CardTitle } from './cardStyles'
import { getDocName } from 'hooks/useDocListData'
import AcceptSpinner from 'components/AcceptSpinner'

const InprogressCard = ({ id, progressCount = 0, ...props }) => {
    const documentName = getDocName(props)

    return (
        <Card
            tabIndex={0}
            data-testid={id}
            sx={{
                border: '1px solid rgb(5, 98, 210)',
                justifyContent: 'center',
                borderRadius: 4,
                padding: 4,
                gap: '0',
                boxShadow: '0'
            }}
        >
            <Box>
                <CardTitle
                    sx={{
                        typography: 'boldBody2',
                        letterSpacing: '0'
                    }}
                    data-testid="document-name"
                >
                    {documentName}
                </CardTitle>
            </Box>
            <AcceptSpinner />
        </Card>
    )
}

InprogressCard.propTypes = {
    id: PropTypes.number,
    selectFile: PropTypes.func,
    progressCount: PropTypes.number,
    onKeyDownHandler: PropTypes.func
}

export default InprogressCard
